import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrganizationStateService {
  private orgResponseSubject = new BehaviorSubject<any>(null);
  orgResponse$ = this.orgResponseSubject.asObservable();

  setOrgResponse(response: any) {
    this.orgResponseSubject.next(response);
  }

  clearOrgResponse() {
    this.orgResponseSubject.next(null);
  }
}
